import React from "react";
import Paginator from "./Paginator";

const itemsPerPage = 8;

class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = { itemsPerPage: itemsPerPage, pages: [], currentPage: 0 };

    //    this.setupData(props);
  }

  componentDidMount() {
    this.setupData(this.props);
  }

  componentWillReceiveProps(newProps, newState) {
    this.setupData(newProps);
  }

  setupData(props) {
    const pageCount = Math.ceil(props.data.length / itemsPerPage);

    let pages = [];
    for (var i = 0; i < pageCount; i++) {
      const start = i * itemsPerPage;
      let end = start + itemsPerPage;
      if (end >= props.data.length) end = props.data.length;
      pages.push(props.data.slice(start, end));
    }

    this.setState({ itemsPerPage: itemsPerPage, pages: pages, currentPage: 0 });
  }

  renderItem(itm, index, total, isHeader, itemIndex) {
    let className = "";
    if (index === 0) className = "TableCell-First";
    if (index === total - 1) className = "TableCell-Last";

    const isSelectable =
      this.props.colSelectables && this.props.colSelectables.includes(index);

    if (isHeader)
      return (
        <th key={index} className={className}>
          {itm}
        </th>
      );
    else
      return (
        <td
          key={index}
          id={isSelectable ? "selectable" : ""}
          className={className}
          onClick={() => {
            this.props.onItemSelected(itemIndex, index);
          }}
        >
          {itm}
        </td>
      );
  }

  renderRow(itm, index, isHeader) {
    const itemIndex =
      index - 1 + this.state.currentPage * this.state.itemsPerPage;
    const row = itm.items.map((value, index, arr) => {
      return this.renderItem(value, index, arr.length, isHeader, itemIndex);
    });

    const className = isHeader ? "Table-Header" : "";
    return (
      <tr key={index} className={className}>
        {row}
      </tr>
    );
  }

  onNavigate(newPage) {
    this.setState({ currentPage: newPage });
  }

  render() {
    if (this.state.pages.length <= 0) return this.props.children;

    const tableHeader = this.props.header.map((value, index) => {
      return this.renderRow(value, index, true);
    });

    const tableItems = this.state.pages[this.state.currentPage].map(
      (value, index) => {
        return this.renderRow(value, index + 1, false);
      }
    );

    return (
      <div className="Table">
        <table>
          <tbody>
            {tableHeader}
            {tableItems}
          </tbody>
        </table>
        <Paginator
          totalPages={this.state.pages.length}
          onNavigate={newPage => this.onNavigate(newPage)}
        />
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table.js